<script setup lang="ts">
import { defineProps, computed } from "vue";
import { useTheme } from "~/composables/useTheme";

const { colors, themeName } = useTheme();

const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    default: "#0027AF",
  },
  width: {
    type: String,
    default: "auto",
  },
  borderRadius: {
    type: String,
    default: "6px",
  },
});

// Compute width
const computedWidth = computed(() => {
  if (props.width === "full") return "100%";
  if (props.width === "auto") return "auto";
  return props.width;
});

// Theme-based background color
const bgColor = colors.secondaryBadge;

// Theme-based icon color
const iconColor = computed(() =>
  themeName.value === "dark" ? "#FFF" : "#002FA7"
);

// Fixed border color
const borderColor = "#002FA7";
</script>

<template>
  <div
    :style="{
      display: 'flex',
      alignItems: 'center',
      gap: '3px',
      width: computedWidth,
      backgroundColor: bgColor,
      // border: `1px solid ${borderColor}`,
      color: colors.primaryText,
      // borderRadius: borderRadius,
      borderTopLeftRadius: props.borderRadius,
      borderBottomLeftRadius: props.borderRadius,
      // borderTopRightRadius: '0',
      // borderBottomRightRadius: '0',
      borderTopRightRadius: props.borderRadius,
      borderBottomRightRadius: props.borderRadius,
      padding: '4px 8px',
      cursor: 'default',
    }"
  >
    <!-- SVG Icon (Reactive fill color) -->
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18px"
      viewBox="0 0 24 24"
      width="18px"
      :fill="iconColor"
      style="display: flex"
    >
    <g><rect fill="none" height="24" width="24" /></g>
      <g>
        <g>
          <circle cx="9" cy="13" r="1.25" />
          <circle cx="15" cy="13" r="1.25" />
          <path
            d="M22.91,11.96C22.39,6.32,17.66,2,12,2S1.61,6.32,1.09,11.96l-0.9,9.86C0.09,22.99,1.01,24,2.19,24h19.62 c1.18,0,2.1-1.01,1.99-2.18L22.91,11.96z M4.54,9.13C5.41,9.68,6.43,10,7.5,10C9.36,10,11,9.07,12,7.65C13,9.07,14.64,10,16.5,10 c1.07,0,2.09-0.32,2.96-0.87C19.8,10.02,20,10.99,20,12c0,4.41-3.59,8-8,8s-8-3.59-8-8C4,10.99,4.2,10.02,4.54,9.13z"
          />
        </g>
      </g>
    </svg>

    <small :style="{ color: colors.quaternaryText }">{{ text }}</small>
  </div>
</template>

<style scoped>
div {
  width: max-content !important;
}
small {
  font-size: 11px;
}

@media (min-width: 1025px) {
  small {
    font-size: 12px;
  }
}
</style>
